import React, { useState, useEffect } from "react";
import Table from 'react-bootstrap/Table';

const Extrato = (props) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(props.rows)
  }, [props.rows]);

  const renderSA = (lines) => {
    let obj = lines.find(x => x.movimento === "Saldo Anterior");

    if (obj)
    {
      return (
      <tr className="row-background">
      <td className="pt-4 pb-3">{obj.data}</td>
      <td className="pt-4 pb-3">{obj.movimento}</td>
      <td className="pt-4 pb-3 pe-3 table-border-right text-end">{obj.cotacao}</td>
      <td className="pt-4 pb-3 ps-3 text-end">{obj.unidadesAssoc}</td>
      <td className="pt-4 pb-3 text-end">{obj.unidadesPart}</td>
      <td className="pt-4 pb-3 pe-3 table-border-right text-end">{obj.unidadesTotal}</td>
      <td className="pt-4 pb-3 ps-3 text-end">{obj.montanteAssoc }</td>
      <td className="pt-4 pb-3 text-end">{obj.montantePart}</td>
      <td className="pt-4 pb-3 text-end">{obj.montanteTotal }</td>
      </tr>
      )
    }
  };

  return (
    <div>
      {rows.map((r, i) => (
      <div key={i}>
      <h3 className="mt-5" id={"canvasTtl" + i}>{r.nome}</h3>
      <Table borderless responsive="md" className="mt-4 complex-table" id={"canvasTable" + i}>
        <thead>
          <tr style={{color:'#3F5B78'}}>
              <th className="pb-3">Data</th>
              <th className="pb-3">Operação</th>
              <th className="pb-3 pe-3 table-border-right text-end">Cotação</th>
              <th className="pb-3 ps-3 pe-3 table-border-right text-center" colSpan={3}>N.º unidades participação (UPs)</th>
              <th className="pb-3 ps-3 text-center" colSpan={3}>Montante (EUR)</th>
          </tr>
          <tr style={{color:'#3F5B78'}}>
              <th className="pb-3 pe-3 table-border-right" colSpan={3}></th>
              <th className="pb-3 ps-3 text-end" style={{fontWeight:'normal'}}>Associado</th>
              <th className="pb-3 text-end" style={{fontWeight:'normal'}}>Participante</th>
              <th className="pb-3 pe-3 table-border-right text-end" style={{fontWeight:'400'}}>Total</th>
              <th className="pb-3 ps-3 text-end" style={{fontWeight:'normal'}}>Associado</th>
              <th className="pb-3 text-end" style={{fontWeight:'normal'}}>Participante</th>
              <th className="pb-3 text-end" style={{fontWeight:'normal'}}>Total</th>
          </tr>
        </thead>
        {props.type === 1 && (
          <tbody>
            <tr className="row-background">
                <td className="pt-4 pb-3">{rows[i].moviments[0].data}</td>
                <td className="pt-4 pb-3">{rows[i].moviments[0].movimento}</td>
                <td className="pt-4 pb-3 pe-3 table-border-right text-end">{rows[i].moviments[0].cotacao}</td>
                <td className="pt-4 pb-3 ps-3 text-end">{rows[i].moviments[0].unidadesAssoc}</td>
                <td className="pt-4 pb-3 text-end">{rows[i].moviments[0].unidadesPart}</td>
                <td className="pt-4 pb-3 pe-3 table-border-right text-end">{rows[i].moviments[0].unidadesTotal}</td>
                <td className="pt-4 pb-3 ps-3 text-end">{rows[i].moviments[0].montanteAssoc}</td>
                <td className="pt-4 pb-3 text-end">{rows[i].moviments[0].montantePart}</td>
                <td className="pt-4 pb-3 text-end">{rows[i].moviments[0].montanteTotal}</td>
              </tr>
              {renderSA(rows[i].moviments)}
          </tbody>
        )}
        {props.type === 2 && (
          <tbody>
          {rows[i].moviments.map((m, j) => (
              <tr key={j} className={(j == 0 || j == rows[i].moviments.length - 1) ? "row-background" : ""}>
                <td className="pt-4 pb-3">{m.data}</td>
                <td className="pt-4 pb-3">{m.movimento}</td>
                <td className="pt-4 pb-3 pe-3 table-border-right text-end">{m.cotacao}</td>
                <td className="pt-4 pb-3 ps-3 text-end">{m.unidadesAssoc}</td>
                <td className="pt-4 pb-3 text-end">{m.unidadesPart}</td>
                <td className="pt-4 pb-3 pe-3 table-border-right text-end">{m.unidadesTotal}</td>
                <td className="pt-4 pb-3 ps-3 text-end">{m.montanteAssoc}</td>
                <td className="pt-4 pb-3 text-end">{m.montantePart}</td>
                <td className="pt-4 pb-3 text-end">{m.montanteTotal}</td>
              </tr>
            ))}
            </tbody>
          )}
      </Table>
      </div>
      ))}
      </div>
  );
};

export default Extrato;
